import { useContext } from 'react'
import { AuthStoreContext } from './AuthStoreProvider'

const useAuthStore = () => useContext(AuthStoreContext)
export default useAuthStore
